import { Storage } from "@faire/web--source/common/Storage";

export const saveSocialMedia = (socialMedia: string | undefined) => {
  if (socialMedia) {
    Storage.session.setItem(OWF_GRANT_SOCIAL_MEDIA, socialMedia);
  }
};

export const getSocialMedia = () => {
  return Storage.session.getItem(OWF_GRANT_SOCIAL_MEDIA);
};

export const clearSocialMedia = () => {
  return Storage.session.removeItem(OWF_GRANT_SOCIAL_MEDIA);
};

export const OWF_GRANT_SOCIAL_MEDIA = "OWF_GRANT_SOCIAL_MEDIA";
